<template>
	<div class="tab" data-name="otherInfo" data-type="form">
		<h3>فرم اطلاعات فردی</h3>
		<p>[ این فرم جهت تکمیل اطلاعات فردی شما می باشد]</p>
		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<label>وضعیت جسمانی</label>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="health"
						   id="healthy"
						   value="سالم" />
					<label class="form-check-label" for="healthy">سالم</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="health"
						   id="unHealthy"
						   value="ناسالم" />
					<label class="form-check-label" for="unHealthy">ناسالم</label>
				</div>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<div class="row mb-3">
					<label>گواهینامه رانندگی</label>
				</div>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="licence"
						   id="have"
						   value="دارم" />
					<label class="form-check-label" for="have">دارم</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="licence"
						   id="notHave"
						   value="ندارم" />
					<label class="form-check-label" for="notHave">ندارم</label>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<div class="row mb-3">
					<label>وضعیت نظام وظیفه</label>
				</div>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="soldier"
						   id="freedom"
						   value="معافیت" />
					<label class="form-check-label" for="freedom">معافیت</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="soldier"
						   id="end"
						   value="پایان خدمت" />
					<label class="form-check-label" for="end">پایان خدمت</label>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<div class="row mb-3">
					<label>نوع همکاری</label>
				</div>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="work"
						   id="partTime"
						   value="نیمه وقت" />
					<label class="form-check-label" for="partTime">نیمه وقت</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="work"
						   id="fullTime"
						   value="تمام وقت" />
					<label class="form-check-label" for="fullTime">تمام وقت</label>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<label>وضعیت تاهل</label>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="marriage"
						   id="single"
						   value="مجرد" />
					<label class="form-check-label" for="single">مجرد</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="marriage"
						   id="married"
						   value="متاهل" />
					<label class="form-check-label" for="married">متاهل</label>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-md-4 col-12">
				<label>ایا همسر شما شاغل است؟</label>
			</div>
			<div class="col-md-8 col-12">
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="employed"
						   id="yes"
						   value="بله" />
					<label class="form-check-label" for="yes">بله</label>
				</div>
				<div class="form-check form-check-inline">
					<input @change="change"
						   class="form-check-input"
						   type="radio"
						   name="employed"
						   id="no"
						   value="خیر" />
					<label class="form-check-label" for="no">خیر</label>
				</div>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col col-4">
				<label>نام و نام خانوادگی همسر</label>
			</div>
			<div class="col col-12 col-md-8">
				<input type="text"
					   @change="change"
					   class="form-control form-control-sm"
					   name="partner"
					   id="partner"
					   placeholder />
			</div>
		</div>

		<div class="row mb-3">
			<div class="col col-12 col-md-4">
				<label for="jobSide">سمت</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control form-control-sm"
					   name="jobSide"
					   id="jobSide"
					   @change="change"
					   data-pattern="checkEmpty" />
			</div>
		</div>
		<div class="row mb-3">
			<div class="col col-12 col-md-4">
				<label for="company">موسسه/شرکت</label>
			</div>
			<div class="col-12 col-md-8">
				<input type="text"
					   class="form-control form-control-sm"
					   name="company"
					   id="company"
					   @change="change"
					   data-pattern="checkEmpty" />
			</div>
		</div>

	</div>
</template>
<style scoped>
	.form-check {
		min-width: 150px;
	}
</style>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function
			},
			contract: {
				type: Object,
			},
		},

		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		}
	};
</script>
